import React from 'react'
import styled from 'styled-components'
import { textStyle2, titleStyle3 } from 'components/magic/styled'
import mediaQuery from 'styles/mediaQuery'
import { FEATURES } from 'constants/magic/features'

import colors from 'styles/colors'
import { Link } from 'gatsby'

const Wrapper = styled.ul`
  list-style: none;
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;

  & > * {
    min-width: 0;
  }
`

const ProductListItem = styled.li`
  padding: 0 15px;
  margin-bottom: 30px;

  ${mediaQuery.mobile} {
    width: 100%;
  }

  ${mediaQuery.tablet} {
    flex: 0 0 50%;
    margin-bottom: 30px;
  }

  ${mediaQuery.bigTablet} {
    flex: 0 0 33.333%;
    margin-bottom: 40px;
  }

  ${mediaQuery.desktopMin} {
    flex: 0 0 33.333%;
    margin-bottom: 55px;
  }
`

const DecorationDot = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
  margin: 0 auto 14px;
  transition: 0.3s ease all;
  filter: grayscale(80%);

  &:after,
  &:before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: linear-gradient(94.96deg, #f26bcd 8.93%, #c567f4 94.95%);
  }

  &:before {
    width: 80px;
    height: 80px;
    opacity: 0.3;
  }

  &:after {
    width: 46px;
    height: 46px;
  }
`

const Card = styled(Link)`
  background: #18181c;
  border-radius: 20px;
  padding: ${({ fullSize }) => (fullSize ? '48px 20px 20px' : '20px')};
  text-align: center;
  height: 100%;
  display: block;
  text-decoration: none;
  cursor: pointer;
  width: 100%;

  &:hover ${DecorationDot} {
    filter: grayscale(0);
  }
`

const ProductTitle = styled.h5`
  ${titleStyle3};
  color: ${colors.white};
  margin-bottom: ${({ fullSize }) => (fullSize ? '14px' : '0px')};
`
const ProductText = styled.p`
  ${textStyle2};
`

const ProductsList = ({ shouldShowText }) => (
  <Wrapper>
    {FEATURES.map(({ title, previewText, text, id }) => (
      <ProductListItem key={title}>
        <Card to={`/product/#${id}`} fullSize={shouldShowText}>
          <DecorationDot />
          <ProductTitle fullSize={shouldShowText}>{title}</ProductTitle>
          {shouldShowText && <ProductText>{previewText || text}</ProductText>}
        </Card>
      </ProductListItem>
    ))}
  </Wrapper>
)

export default ProductsList
